<template>
  <span class="scaling-svg-container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12.938"
      height="14.376"
      viewBox="0 0 12.938 14.376"
      class="scaling-svg"
    >
      <path
        d="M10.782,14.376a.72.72,0,0,1-.719-.719V9.93a2.143,2.143,0,0,1,0-4.046V.719a.719.719,0,1,1,1.438,0V5.883a2.143,2.143,0,0,1,0,4.046v3.727A.72.72,0,0,1,10.782,14.376Zm0-7.187a.719.719,0,1,0,.719.718A.719.719,0,0,0,10.782,7.188ZM6.469,14.376a.72.72,0,0,1-.719-.719V4.18a2.156,2.156,0,1,1,1.438,0v9.477A.72.72,0,0,1,6.469,14.376Zm0-12.938a.719.719,0,1,0,.719.719A.72.72,0,0,0,6.469,1.437ZM2.156,14.376a.72.72,0,0,1-.719-.719v-.851a2.143,2.143,0,0,1,0-4.046V.719a.719.719,0,0,1,1.438,0v8.04a2.143,2.143,0,0,1,0,4.046v.851A.72.72,0,0,1,2.156,14.376Zm0-4.313a.719.719,0,1,0,.719.719A.72.72,0,0,0,2.156,10.063Z"
        transform="translate(0 0)"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class OptionsFilter extends Vue {}
</script>
